import '@ncino/styles/gator'
import Vue from 'vue'
import { toasterService } from '@ncino/web-components/services'

Vue.config.ignoredElements = Vue.config.ignoredElements || []
if (!Vue.config.ignoredElements.some(e => e instanceof RegExp && e.source === '^ngc-')) {
  Vue.config.ignoredElements.push(/^ngc-/)
}

Vue.prototype.$toasterService = toasterService

// On a hard page load Chrome autofills Gator's search box with the saved login
// for this origin, which silently filters the table to nothing. Every
// declarative opt-out (autocomplete="off", name, type="search") was tried and
// Chrome ignores all of them. It cannot fill a readonly input though, so hold
// the field readonly just long enough to survive the load-time autofill pass,
// then release it for good - after that the input behaves exactly as normal
// (caret, typing, backspace) and never re-arms. Chrome may still
// offer the saved login in a dropdown on click; that is only a suggestion and
// does not fill anything, so it is left alone.
// Usage: <ngc-input-search v-suppress-autofill ... />
const SUPPRESS_AUTOFILL_MS = 1000

const whenRendered = async (el) => {
  await customElements.whenDefined(el.localName)
  if (el.updateComplete) {
    await el.updateComplete
  }
}

const suppressAutofill = async (el) => {
  if (!el || !el.localName || !el.localName.startsWith('ngc-')) {
    return
  }
  try {
    await whenRendered(el)

    // ngc-input-search renders its field as a nested <ngc-input-text>, so the
    // native <input> sits two shadow roots down. querySelector does not pierce
    // shadow boundaries, hence the explicit hop.
    const inner = el.shadowRoot && el.shadowRoot.querySelector('ngc-input-text, ngc-input-dropdown')
    if (inner) {
      await whenRendered(inner)
    }

    const root = (inner || el).shadowRoot
    const input = root && root.querySelector('input')
    if (!input) {
      return
    }

    input.setAttribute('readonly', 'readonly')
    const release = () => {
      clearTimeout(timer)
      input.removeAttribute('readonly')
      input.removeEventListener('focus', release)
      input.removeEventListener('pointerdown', release)
    }
    // Chrome's autofill pass runs within a few hundred ms of load, so the field
    // only has to hold out that long. Releasing on a timer as well as on
    // interaction keeps the input out of Cypress's way - cy.type() rejects a
    // readonly element before it ever focuses it, but it retries, so by the
    // time it retries the attribute is gone.
    const timer = setTimeout(release, SUPPRESS_AUTOFILL_MS)
    input.addEventListener('focus', release)
    input.addEventListener('pointerdown', release)
  } catch (_err) {
    // Element never upgraded, or has no shadow input - nothing to suppress.
  }
}

Vue.directive('suppress-autofill', {
  inserted: suppressAutofill
})

if (!window.__ncinoComponentsPromise) {
  window.__ncinoComponentsPromise = null
}

export function ensureNcinoWebComponents () {
  if (window.__ncinoComponentsPromise) {
    return window.__ncinoComponentsPromise
  }

  window.__ncinoComponentsPromise = import('@ncino/web-components/dist/index.gator.js')
  return window.__ncinoComponentsPromise
}
